import gql from "graphql-tag";

export const GetTranscriptsByTaxRiskReportId = gql`
  query GetTranscriptsByTaxRiskReportId($taxRiskReportId: ID!, $years: [Int]!) {
    GetTranscriptsByTaxRiskReportId(TaxRiskReportId: $taxRiskReportId, Years: $years, UrlTimeout: "10") {
      Name
      PresignedUrl
    }
  }
`;
